import catDict from '../config/category-dict'

export default {
    methods: {
        titleString: function() {
            let route = this.currentRouteName(), cat, area, city, company
            
            if (/area/.test(route)) {
                area = this.$store.getters['result/addArea']
            }
            if (/city/.test(route)) {
                city = this.$store.getters['result/addCity']
            }
            if (/company/.test(route)) {
                company = this.$store.getters['result/companyName']
            }


            if (/^search-form/.test(route)) {
                return '保育士の求人を探す'

            } else if (/^search/.test(route)) {
                cat = catDict.get(this.$store.getters['result/category'])
                if (city !== void 0) {
                    return area + city + 'の' + cat + '求人'
                } else if (area !== void 0) {
                    return area + 'の' + cat + '求人'
                } else if (/^job/.test(this.$store.getters['result/category'])) {
                    return cat + 'の求人'
                }
                return cat + 'の保育士求人'

            } else if (/^area/.test(route)) {
                if (city !== void 0) {
                    return area + city + 'の保育士求人'
                }
                return area + 'の保育士求人'

            
            } else if (/^company/.test(route)) {
                if (area !== void 0) {
                    return company + ' ' + area + 'の保育士求人'
                }
                return company + 
                       'の保育士・幼稚園教諭の転職情報、求人募集を探すなら'

            
            } else if (/^result/.test(route)) {
                let condition = this.$store.getters['result/condition'], arr = []
                for (let k of Object.keys(condition)) {
                    if (condition[k]) {
                        if (typeof condition[k] == 'object') {
                            for (let e of condition[k]) {
                                if (e) {
                                    arr.push(e)
                                }
                            }
                        } else {
                            arr.push(condition[k])
                        }
                    }
                }

                return arr.length > 0 ? arr.join(' / ') + 'の求人' : '求人検索結果'

            } else if (route == 'entry') {
                return '応募フォーム'
            } else if (route == 'detail') {
                return this.$store.getters['detail/isNotfound'] ? 
                    '保育士・幼稚園教諭の転職情報、求人募集を探すなら' : 
                    this.$store.getters['detail/name'] + 'の求人情報'
            }

            return '保育士・幼稚園教諭の転職情報、求人募集を探すなら'
        },

        setTitleTag: function() {
            if (this.currentRouteName() != 'top') {
                document.title = this.titleString() + '｜ケアキャリアナビ' 
            }
        }
    },
}
